import * as THREE from "three";
import Material from "./Material"
import { defaultMaterial } from "../../utils/defaultMaterial";

export default class MaterialPair
{
    materialData: Material;
    threeJsMaterial: THREE.Material | undefined;

    constructor(materialData: Material, threeJsMaterial : THREE.Material | undefined)
    {
        this.materialData = materialData;
        this.threeJsMaterial = threeJsMaterial;
    }

    getThreeJsMaterial() : THREE.Material {
        return this.threeJsMaterial 
                ? this.threeJsMaterial 
                : defaultMaterial;
    }
}